module.exports = __webpack_public_path__ + "static/img/gengxin2.439538b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bottom/blue/gengxin2.png
// module id = 2Nv1
// module chunks = 24